import type { AxiosError } from 'axios';
import axiosInstance from '@/services/interceptor.services';
import type {
  IDeclarationTree,
  IUpdateDeclarationsBody,
} from '@/components/product/edit/regulatory-declarations.types';

export const RegulatoryDeclarationsService = {
  /**
   * Récupère les déclarations d'allergènes d'un produit (produit, variantes,
   * options). Les entrées variants/customAddons sans aucune déclaration sont
   * omises par l'API.
   */
  getRegulatoryDeclarations: async (productId: string) => {
    try {
      const response = await axiosInstance.get<{
        data: IDeclarationTree;
        message: string;
      }>(`products/${productId}/regulatory-declarations`);
      return response;
    } catch (error) {
      const err = error as AxiosError;
      return Promise.reject(err);
    }
  },

  /**
   * Remplace intégralement les déclarations d'allergènes d'un produit.
   */
  updateRegulatoryDeclarations: async (
    productId: string,
    body: IUpdateDeclarationsBody,
  ) => {
    try {
      const response = await axiosInstance.put<{ message: string }>(
        `products/${productId}/regulatory-declarations`,
        body,
      );
      return response;
    } catch (error) {
      const err = error as AxiosError;
      return Promise.reject(err);
    }
  },
};
